import { catchError } from 'rxjs/operators';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractHttpService } from './http-abstract.service';
import { ConfigDto, GenerateOtpDto, SectionDto, ServiceSelectionDto } from './dtos';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class HttpOtpService extends AbstractHttpService {
	constructor(http: HttpClient) {
        super(http);
    }

    // generateOtp(userRef: string, email: string, recordAction: string, profileType: string): Observable<SectionDto> {
	generateOtp(serviceSelection: ServiceSelectionDto): Observable<SectionDto> {
		var payload: GenerateOtpDto = {
			userRef: serviceSelection.idNumber,
			msisdn: serviceSelection.msisdn,
			email: serviceSelection.email,
			recordAction: serviceSelection.recordAction,
			profileType: serviceSelection.profileType,
			name: serviceSelection.name,
			surname: serviceSelection.surname,
			dateOfBirth: serviceSelection.dateOfBirth,
			cap: serviceSelection.cap,
		};

        return super.post(`/generateOtp`, payload);
    }

}